module.exports = __webpack_public_path__ + "static/media/download_xlsx.52a7798f.png";